import { Component, OnInit, OnDestroy, ElementRef, ViewChild, AfterViewInit } from '@angular/core';
import { Router } from '@angular/router';
import { interval, Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { Howl, Howler } from 'howler';
import { ConnectionService } from 'ng-connection-service';
import { AuthenticationService } from '../authentication.service';
import { TicketcontrolService } from '../ticketcontrol.service';

@Component({
  selector: 'app-ticketcontrol',
  templateUrl: './ticketcontrol.component.html',
  styleUrls: ['./ticketcontrol.component.css']
})
export class TicketcontrolComponent implements OnInit, OnDestroy {

  @ViewChild('scannerinputl') scannerinputl:ElementRef;
  @ViewChild('scannerinput2') scannerinput2:ElementRef;
  @ViewChild('scannerinput3') scannerinput3:ElementRef;
  @ViewChild('scannerinput4') scannerinput4:ElementRef;

  apikey: any;
  entrylogs: any;
  entrylogsSummary: any;
  totalAttendies: any;
  totalCheckedIn: any;
  currEvent: any;
  searchlog: any;
  searchlogResults: any;
  pendingbreakdown: any;
  checkedbreakdown: any;
  totalbreakdown: any;
  allLogs: any;
  logsLiveCount: any;
  scanner1: any;
  scanner2: any;
  scanner3: any;
  scanner4: any;

  scanner1status: any;
  scanner1statusword: any;
  scanner1buyername: any;
  scanner1tickettype: any;
  scanner1data: any;

  scanner2status: any;
  scanner2statusword: any;
  scanner2buyername: any;
  scanner2tickettype: any;
  scanner2data: any;

  scanner3status: any;
  scanner3statusword: any;
  scanner3buyername: any;
  scanner3tickettype: any;
  scanner3data: any;

  scanner4status: any;
  scanner4statusword: any;
  scanner4buyername: any;
  scanner4tickettype: any;
  scanner4data: any;

  sound: any;
  isConnected: any;
  internetStatus: any;
  localData: any;
  showLocalDataModal: boolean = false;
  showScannedDeviceModal: boolean = false;
  scannedDeviceData: any = {}; // Store by API key: { apikey: [{code, name, type, timestamp}, ...] }
  syncingApiKeys: any = {}; // Track syncing status per API key: { apikey: true/false }
  storageError: string = '';
  storageAvailable: boolean = true;
  isSyncing: boolean = false;
  
  private destroy$ = new Subject<void>();
  private isUpdatingCount = false;
  private isGettingLogsCount = false;
  private syncLock: boolean = false;
  private memoryFallback: any[] = []; // In-memory fallback if localStorage fails
  private maxLocalDataSize: number = 10000; // Maximum items to prevent storage bloat
  private syncRetryAttempts: number = 3;
  private syncRetryDelay: number = 2000; // 2 seconds

  constructor(private auth: AuthenticationService, private router: Router, private controlService: TicketcontrolService, private connectionService: ConnectionService) {
    this.apikey = '';
    this.totalAttendies = 0;
    this.totalCheckedIn = 0;
    this.currEvent = 'No API KEY ADDED';
    this.searchlog = '';
    this.searchlogResults = [];
    this.pendingbreakdown = [];
    this.checkedbreakdown = [];
    this.totalbreakdown = [];
    this.allLogs = [];

  	this.scanner1 = '';
  	this.scanner2 = '';
  	this.scanner3 = '';
  	this.scanner4 = '';

  	this.scanner1status = '';
  	this.scanner1statusword = '';
  	this.scanner1buyername = '';
  	this.scanner1tickettype = '';
  	this.scanner1data = [];

  	this.scanner2status = '';
  	this.scanner2statusword = '';
  	this.scanner2buyername = '';
  	this.scanner2tickettype = '';
  	this.scanner2data = [];

  	this.scanner3status = '';
  	this.scanner3statusword = '';
  	this.scanner3buyername = '';
  	this.scanner3tickettype = '';
  	this.scanner3data = [];

  	this.scanner4status = '';
  	this.scanner4statusword = '';
  	this.scanner4buyername = '';
  	this.scanner4tickettype = '';
    this.scanner4data = [];

    this.entrylogs = [];
    this.entrylogsSummary = [];
    this.logsLiveCount = [];

    this.sound = new Howl({
      src: ['assets/sound.mp3']
    });

    this.internetStatus = "ONLINE";
    this.isConnected = true;
    this.localData = [];
    
    // Check storage availability
    this.checkStorageAvailability();
    
    // Enhanced connection monitoring with retry logic
    this.connectionService.monitor().subscribe(isConnected => {
      const wasOffline = !this.isConnected;
      this.isConnected = isConnected;
      
      if (this.isConnected) {
        this.internetStatus = "ONLINE";
        // Only sync if we were previously offline to avoid unnecessary syncs
        if (wasOffline) {
          setTimeout(() => {
            this.syncLocalData();
          }, 500); // Small delay to ensure connection is stable
        }
      } else {
        this.internetStatus = "OFFLINE";
      }
    });
    
    // Periodic sync check when online (every 30 seconds)
    interval(1000 * 30)
      .pipe(takeUntil(this.destroy$))
      .subscribe(() => {
        if (this.isConnected && this.localData.length > 0 && !this.isSyncing) {
          this.syncLocalData();
        }
      });

    // Use exhaustMap to prevent overlapping requests - only starts new request if previous one completed
    interval(1000 * 10)
      .pipe(
        takeUntil(this.destroy$)
      )
      .subscribe(() => {
        // Only proceed if not already processing and API key is set
        if (!this.isUpdatingCount && !this.isGettingLogsCount && this.apikey !== '') {
          this.safeUpdateCount();
          this.safeGetLogsCount();
        }
      });
  }

  ngOnDestroy() {
    // Clean up subscriptions to prevent memory leaks
    this.destroy$.next();
    this.destroy$.complete();
  }

  ngOnInit() {
  	let userRole = this.auth.getRole();
    if(userRole != 'administrator') {
      this.router.navigateByUrl('/profile');
    } else {
    	// console.log(`I am Administrator`);
    }
    this.loadLocalDataFromStorage();
    this.loadAllLogsFromStorage();
    this.loadScannedDeviceData();
    this.switchinputs();

  }

  updateLocalData(scannedCode: string) {
    // Validate input
    if (!scannedCode || typeof scannedCode !== 'string' || scannedCode.trim() === '') {
      console.warn('Invalid scanned code:', scannedCode);
      return;
    }
    
    const trimmedCode = scannedCode.trim();
    
    // Only store if offline OR if online but API key not set (defensive approach)
    if (!this.isConnected || !this.apikey) {
      // Prevent duplicates
      if (this.localData.indexOf(trimmedCode) === -1 && this.memoryFallback.indexOf(trimmedCode) === -1) {
        this.localData.push(trimmedCode);
        
        // Prevent storage bloat - remove oldest if exceeds limit
        if (this.localData.length > this.maxLocalDataSize) {
          this.localData.shift(); // Remove oldest entry
        }
        
        // Save to storage (with error handling)
        const saved = this.saveLocalDataToStorage();
        
        // If storage failed, use memory fallback
        if (!saved) {
          this.memoryFallback.push(trimmedCode);
          if (this.memoryFallback.length > this.maxLocalDataSize) {
            this.memoryFallback.shift();
          }
        }
      }
    }
  }

  getLocalStorageKey() {
    return 'ticketcontrol_localdata_' + (this.apikey || 'default');
  }

  getAllLogsStorageKey() {
    return 'ticketcontrol_alllogs_' + (this.apikey || 'default');
  }

  // Check if localStorage is available and working
  checkStorageAvailability(): boolean {
    try {
      if (typeof Storage === 'undefined') {
        this.storageAvailable = false;
        this.storageError = 'localStorage not supported';
        return false;
      }
      
      const testKey = '__storage_test__';
      localStorage.setItem(testKey, 'test');
      localStorage.removeItem(testKey);
      this.storageAvailable = true;
      this.storageError = '';
      return true;
    } catch (e) {
      this.storageAvailable = false;
      const error = e as any;
      if (error.name === 'QuotaExceededError' || error.name === 'NS_ERROR_DOM_QUOTA_REACHED') {
        this.storageError = 'Storage quota exceeded';
      } else if (error.code === 22 || error.code === 1014) {
        this.storageError = 'Storage quota exceeded';
      } else {
        this.storageError = 'Storage not available';
      }
      return false;
    }
  }

  loadLocalDataFromStorage() {
    // Always initialize as array
    this.localData = [];
    this.memoryFallback = [];
    
    if (!this.storageAvailable && !this.checkStorageAvailability()) {
      console.warn('Storage not available, using memory fallback only');
      return;
    }
    
    try {
      const storageKey = this.getLocalStorageKey();
      const storedData = localStorage.getItem(storageKey);
      
      if (storedData) {
        // Validate JSON before parsing
        let parsedData: any;
        try {
          parsedData = JSON.parse(storedData);
        } catch (parseError) {
          console.error('Invalid JSON in storage, clearing corrupted data:', parseError);
          localStorage.removeItem(storageKey);
          return;
        }
        
        // Validate data structure
        if (Array.isArray(parsedData)) {
          // Filter out invalid entries
          this.localData = parsedData.filter((item: any) => {
            return typeof item === 'string' && item.trim() !== '';
          });
          
          // Limit size to prevent issues
          if (this.localData.length > this.maxLocalDataSize) {
            this.localData = this.localData.slice(-this.maxLocalDataSize);
            this.saveLocalDataToStorage();
          }
        } else {
          console.warn('Invalid data structure in storage, resetting');
          localStorage.removeItem(storageKey);
          this.localData = [];
        }
      }
      
      // Load memory fallback if exists
      const memoryKey = storageKey + '_memory';
      const memoryData = localStorage.getItem(memoryKey);
      if (memoryData) {
        try {
          const parsedMemory = JSON.parse(memoryData);
          if (Array.isArray(parsedMemory)) {
            this.memoryFallback = parsedMemory.filter((item: any) => {
              return typeof item === 'string' && item.trim() !== '';
            });
            // Merge with localData, removing duplicates
            this.memoryFallback.forEach((code: string) => {
              if (this.localData.indexOf(code) === -1) {
                this.localData.push(code);
              }
            });
            this.memoryFallback = [];
            localStorage.removeItem(memoryKey);
            this.saveLocalDataToStorage();
          }
        } catch (e) {
          localStorage.removeItem(memoryKey);
        }
      }
      
      // If we're online and have stored data, try to sync it
      if (this.isConnected && this.localData.length > 0 && this.apikey) {
        setTimeout(() => {
          this.syncLocalData();
        }, 1000);
      }
    } catch (error) {
      console.error('Error loading local data from storage:', error);
      this.localData = [];
      const err = error as any;
      this.storageError = err.message || 'Unknown storage error';
      this.checkStorageAvailability();
    }
  }

  saveLocalDataToStorage(): boolean {
    // Always ensure localData is an array
    if (!Array.isArray(this.localData)) {
      console.warn('localData is not an array, resetting');
      this.localData = [];
    }
    
    // Check storage availability
    if (!this.storageAvailable && !this.checkStorageAvailability()) {
      return false;
    }
    
    try {
      const storageKey = this.getLocalStorageKey();
      const dataToStore = JSON.stringify(this.localData);
      
      // Check size before storing (rough estimate: 1MB limit)
      const sizeInBytes = new Blob([dataToStore]).size;
      if (sizeInBytes > 2000000) { // 2MB
        console.warn('Data too large, trimming oldest entries');
        this.localData = this.localData.slice(-Math.floor(this.maxLocalDataSize * 0.8));
        return this.saveLocalDataToStorage(); // Retry with smaller data
      }
      
      localStorage.setItem(storageKey, dataToStore);
      
      // Also save timestamp for cleanup
      localStorage.setItem(storageKey + '_timestamp', Date.now().toString());
      
      this.storageError = '';
      return true;
    } catch (error) {
      console.error('Error saving local data to storage:', error);
      const err = error as any;
      
      // Handle quota exceeded
      if (err.name === 'QuotaExceededError' || err.code === 22) {
        this.storageError = 'Storage quota exceeded';
        // Try to free up space by removing oldest entries
        if (this.localData.length > 100) {
          this.localData = this.localData.slice(-100);
          try {
            localStorage.setItem(this.getLocalStorageKey(), JSON.stringify(this.localData));
            return true;
          } catch (retryError) {
            // Still failing, use memory fallback
            this.memoryFallback = [];
            if (this.localData && Array.isArray(this.localData)) {
              this.localData.forEach((code: string) => {
                this.memoryFallback.push(code);
              });
            }
            this.storageAvailable = false;
            return false;
          }
        }
      }
      
      this.storageError = err.message || 'Storage save failed';
      this.checkStorageAvailability();
      return false;
    }
  }

  syncLocalData() {
    // Prevent concurrent syncs
    if (this.syncLock || this.isSyncing) {
      return;
    }
    
    if (!this.apikey) {
      return;
    }
    
    // Combine localData and memoryFallback
    const allPendingData: string[] = [];
    if (this.localData && Array.isArray(this.localData)) {
      this.localData.forEach((code: string) => {
        if (allPendingData.indexOf(code) === -1) {
          allPendingData.push(code);
        }
      });
    }
    if (this.memoryFallback && Array.isArray(this.memoryFallback) && this.memoryFallback.length > 0) {
      this.memoryFallback.forEach((code: string) => {
        if (allPendingData.indexOf(code) === -1) {
          allPendingData.push(code);
        }
      });
    }
    
    if (allPendingData.length === 0) {
      return;
    }
    
    // Check connection before syncing
    if (!this.isConnected) {
      return;
    }
    
    this.syncLock = true;
    this.isSyncing = true;
    
    const syncedIndices: number[] = [];
    const syncedCodes: string[] = [];
    let completedCount = 0;
    const totalCount = allPendingData.length;
    let hasErrors = false;

    // Process in batches to avoid overwhelming the server
    const batchSize = 10;
    let currentBatch = 0;
    
    const processBatch = () => {
      const startIdx = currentBatch * batchSize;
      const endIdx = Math.min(startIdx + batchSize, totalCount);
      const batch = allPendingData.slice(startIdx, endIdx);
      
      if (batch.length === 0) {
        // All batches processed
        this.processSyncedData(syncedIndices, syncedCodes, hasErrors);
        return;
      }
      
      const batchPromises = batch.map((entry, batchIndex) => {
        const actualIndex = startIdx + batchIndex;
        return this.controlService.checkticket(entry, this.apikey)
          .then(data => {
            syncedIndices.push(actualIndex);
            syncedCodes.push(entry);
            completedCount++;
            if (completedCount === totalCount) {
              this.processSyncedData(syncedIndices, syncedCodes, hasErrors);
            }
          })
          .catch(error => {
            console.error('Error syncing entry:', entry, error);
            hasErrors = true;
            completedCount++;
            if (completedCount === totalCount) {
              this.processSyncedData(syncedIndices, syncedCodes, hasErrors);
            }
          });
      });
      
      // Wait for all promises in batch to complete
      Promise.all(batchPromises.map(p => p.catch(() => null))).then(() => {
        currentBatch++;
        // Process next batch with small delay
        setTimeout(() => {
          processBatch();
        }, 100);
      });
    };
    
    processBatch();
  }

  processSyncedData(syncedIndices: number[], syncedCodes: string[], hasErrors: boolean) {
    try {
      // Remove successfully synced items from localData
      const codesToRemove = new Set(syncedCodes);
      this.localData = this.localData.filter((code: string) => !codesToRemove.has(code));
      
      // Remove from memory fallback too
      this.memoryFallback = this.memoryFallback.filter((code: string) => !codesToRemove.has(code));
      
      // Update storage
      if (syncedCodes.length > 0) {
        this.saveLocalDataToStorage();
      }
      
      // If there were errors but we synced some, retry failed ones later
      if (hasErrors && this.localData.length > 0) {
        setTimeout(() => {
          if (this.isConnected && !this.isSyncing) {
            this.syncLocalData();
          }
        }, this.syncRetryDelay);
      }
    } catch (error) {
      console.error('Error processing synced data:', error);
    } finally {
      this.syncLock = false;
      this.isSyncing = false;
    }
  }

  checkTicketLocal(code: any) {
    // console.log(this.allLogs[code]);
    if (typeof this.allLogs[code] != 'undefined') {
      if(parseInt(this.allLogs[code].count)<1) {
        return true
      } else {
        return false;
      }
    } else {
      return false;
    }
  }

  getDataLocal(code: any) {
    var status = false;
    var statusword = 'Not Valid';
    var data = {
      buyername: '',
      code: code,
      event: '',
      status: status,
      statusword: statusword,
      tsupdated: "",
      type: '',
    }

    if (typeof this.allLogs[code]!= 'undefined') {
      if (parseInt(this.allLogs[code].count)<1) {
        this.allLogs[code].count = 1;
        status = true;
        statusword = 'Valid';
        // Save local changes when ticket is marked as used
        this.saveLocalLogChanges();
      } else {
        status = false;
        statusword = 'Used';
      }

      data = {
        buyername: this.allLogs[code].name,
        code: code,
        event: this.allLogs[code].event,
        status: status,
        statusword: statusword,
        tsupdated: "NA",
        type: this.allLogs[code].type,
      }
    } else {
      data = {
        buyername: '',
        code: code,
        event: '',
        status: status,
        statusword: statusword,
        tsupdated: "",
        type: '',
      }
    }

    return data;
  }

  async scanner1inputchange() {

    this.switchinputs();
    this.scanner1status = '';
    this.scanner1buyername = '';
    this.scanner1tickettype = '';
    this.scanner1statusword = '';
    var scanCode = this.scanner1;

    if (this.scanner1!='') {
      this.updateLocalData(this.scanner1);

      var check = await this.checkTicketLocal(this.scanner1);
      // console.log({check});
      this.scanner1data = this.getDataLocal(this.scanner1);
      this.scanner1status = this.scanner1data.status;
      this.scanner1buyername = this.scanner1data.buyername;
      this.scanner1tickettype = this.scanner1data.type;
      this.scanner1statusword = this.scanner1data.statusword;
      this.addToLogs(this.apikey, this.scanner1data);
      this.pushtoentrylogs(this.scanner1data);
      // Store valid scanned entry on device
      this.storeScannedEntry(this.scanner1data);
      if(check) {
        this.playAlarm(this.scanner1data.status);
        this.controlService.checkticket(scanCode, this.apikey).then(data => {
          // console.log("control data sent1");
        }).catch(error => {
          console.log({error});
        });
        // this.scanner1 = '';
      } else {
        this.playAlarm(false);
      }
      this.scanner1 = '';

    }
  }

  async scanner2inputchange() {
    this.switchinputs();
    this.scanner2status = '';
    this.scanner2buyername = '';
    this.scanner2tickettype = '';
    this.scanner2statusword = '';
    var scanCode = this.scanner2;

    if (this.scanner2 != '') {
      this.updateLocalData(this.scanner2);

      var check = await this.checkTicketLocal(this.scanner2);
      // console.log({ check });
      this.scanner2status = this.scanner2data.status;
      this.scanner2buyername = this.scanner2data.buyername;
      this.scanner2tickettype = this.scanner2data.type;
      this.scanner2statusword = this.scanner2data.statusword;
      this.scanner2data = this.getDataLocal(this.scanner2);
      this.addToLogs(this.apikey, this.scanner2data);
      this.pushtoentrylogs(this.scanner2data);
      // Store valid scanned entry on device
      this.storeScannedEntry(this.scanner2data);
      if (check) {
        this.playAlarm(this.scanner2data.status);
        this.controlService.checkticket(scanCode, this.apikey).then(data => {
          // console.log("control data sent2");
        }).catch(error => {
          console.log({error});
        });
        // this.scanner2 = '';
      } else {
        this.playAlarm(false);
      }
      this.scanner2 = '';

    }
  }

  async scanner3inputchange() {
    this.switchinputs();
    this.scanner3status = '';
    this.scanner3buyername = '';
    this.scanner3tickettype = '';
    this.scanner3statusword = '';
    var scanCode = this.scanner3;

    if (this.scanner3 != '') {
      this.updateLocalData(this.scanner3);

      var check = await this.checkTicketLocal(this.scanner3);
      // console.log({ check });
      this.scanner3data = this.getDataLocal(this.scanner3);
      this.scanner3status = this.scanner3data.status;
      this.scanner3buyername = this.scanner3data.buyername;
      this.scanner3tickettype = this.scanner3data.type;
      this.scanner3statusword = this.scanner3data.statusword;
      this.addToLogs(this.apikey, this.scanner3data);
      this.pushtoentrylogs(this.scanner3data);
      // Store valid scanned entry on device
      this.storeScannedEntry(this.scanner3data);
      if (check) {
        this.playAlarm(this.scanner3data.status);
        this.controlService.checkticket(scanCode, this.apikey).then(data => {
          // console.log("control data sent3");
        }).catch(error => {
          console.log({error});
        });
        // this.scanner3 = '';
      } else {
        this.playAlarm(false);
      }
      this.scanner3 = '';

    }
  }

  async scanner4inputchange() {
    this.switchinputs();
    this.scanner4status = '';
    this.scanner4buyername = '';
    this.scanner4tickettype = '';
    this.scanner4statusword = '';
    var scanCode = this.scanner4;

    if (this.scanner4 != '') {
      this.updateLocalData(this.scanner4);

      var check = await this.checkTicketLocal(this.scanner4);
      // console.log({ check });
      this.scanner4data = this.getDataLocal(this.scanner4);
      this.scanner4status = this.scanner4data.status;
      this.scanner4buyername = this.scanner4data.buyername;
      this.scanner4tickettype = this.scanner4data.type;
      this.scanner4statusword = this.scanner4data.statusword;
      this.addToLogs(this.apikey, this.scanner4data);
      this.pushtoentrylogs(this.scanner4data);
      // Store valid scanned entry on device
      this.storeScannedEntry(this.scanner4data);
      if (check) {
        this.playAlarm(this.scanner4data.status);
        this.controlService.checkticket(scanCode, this.apikey).then(data => {
          // console.log("control data sent4");
        }).catch(error => {
          console.log({error});
        });
        // this.scanner4 = '';
      } else {
        this.playAlarm(false);
      }
      this.scanner4 = '';

    }
  }

  switchinputs() {
  	let scanner1 = <HTMLInputElement>document.getElementById("scanner1");
  	let scanner2 = <HTMLInputElement>document.getElementById("scanner2");
  	let scanner3 = <HTMLInputElement>document.getElementById("scanner3");
  	let scanner4 = <HTMLInputElement>document.getElementById("scanner4");
  	if(scanner1.value=='') {
  		this.scannerinputl.nativeElement.focus();
  	}
  	else if(scanner2.value=='') {
  		this.scannerinput2.nativeElement.focus();
  	}
  	else if(scanner3.value=='') {
  		this.scannerinput3.nativeElement.focus();
  	}
  	else if(scanner4.value=='') {
  		this.scannerinput4.nativeElement.focus();
  	}
  }

  pushtoentrylogs(topush) {
    topush.tsupdated = this.currTime();
    this.entrylogs.push(topush);
    this.entrylogsSummary.unshift(topush);
    // console.log(topush);
    if (this.entrylogsSummary.length > 10) this.entrylogsSummary = this.entrylogsSummary.slice(0, 10);
  }

  playAlarm(status) {
    if(status==false) {
      this.sound.play();
    }
  }

  apikeychange() {
    // Load local data for the new API key
    this.loadLocalDataFromStorage();
    this.loadAllLogsFromStorage();
    this.updateCount();
    this.getLogs();
    this.getLogsCount();
    // If online, try to sync any pending data for this API key
    if (this.isConnected && this.localData.length > 0) {
      this.syncLocalData();
    }
  }

  updateCount() {
    if(this.apikey!='') {
      this.controlService.getcount(this.apikey).then(data => {
        let stats: any;
        stats = data;
        // console.log("updateCount:", stats);
        this.pendingbreakdown = stats.pendingbreakdown;
        this.checkedbreakdown = stats.checkedbreakdown;
        this.totalbreakdown = stats.totalbreakdown;

        // Merge server data with local changes (tickets marked as used offline)
        this.mergeAllLogs(stats.alllogs);
        this.saveAllLogsToStorage();

        // console.log(data);
        this.totalAttendies = stats.total;
        this.totalCheckedIn = stats.checkedin;
        this.currEvent = stats.event;
      }).catch(error => {
        console.log(error);
        // If update fails but we have cached allLogs, use them
        if (!this.allLogs || Object.keys(this.allLogs).length === 0) {
          this.loadAllLogsFromStorage();
        }
      });


    }
  }

  // Safe wrapper that prevents overlapping requests
  private safeUpdateCount() {
    if (this.isUpdatingCount || this.apikey === '') {
      return;
    }
    
    this.isUpdatingCount = true;
    this.controlService.getcount(this.apikey)
      .then(data => {
        let stats: any;
        stats = data;
        this.pendingbreakdown = stats.pendingbreakdown;
        this.checkedbreakdown = stats.checkedbreakdown;
        this.totalbreakdown = stats.totalbreakdown;
        // Merge server data with local changes (tickets marked as used offline)
        this.mergeAllLogs(stats.alllogs);
        this.saveAllLogsToStorage();
        
        this.totalAttendies = stats.total;
        this.totalCheckedIn = stats.checkedin;
        this.currEvent = stats.event;
      })
      .catch(error => {
        console.error('Error updating count:', error);
      })
      .finally(() => {
        this.isUpdatingCount = false;
      });
  }

  currTime() {
    var currentdate = new Date();
    var tstime =currentdate.getHours() + ":" + currentdate.getMinutes();
    return tstime;
  }

  filterlog() {
    var selfRef = this;
    this.searchlogResults = this.entrylogs.filter(function(v, i) {
      if (v.buyername.toLowerCase().includes(selfRef.searchlog.toLowerCase())) {
        return true;
      } else if (v.type.toLowerCase().includes(selfRef.searchlog.toLowerCase())) {
        return true;
      } else if (v.code.includes(selfRef.searchlog)) {
        return true;
      } else if (v.tsupdated.includes(selfRef.searchlog)) {
        return true;
      } else {
        return false;
      }
    });
  }

  scrollandsearch(id, code) {
    this.searchlog = code.trim();
    this.filterlog();
    let el = document.getElementById(id);
    el.scrollIntoView();
  }

  addToLogs(apikey, scannerdata) {
    this.controlService.insertLog(apikey, scannerdata)
    .then(data => {
      // console.log({data});
    })
    .catch(error => {
      console.log({error});
    });
  }

  compare(a, b) {
    if (parseInt(a.id) < parseInt(b.id)) {
      return -1;
    }
    if (parseInt(a.id) > parseInt(b.id)) {
      return 1;
    }
    return 0;
  }

  getLogs() {
    if (this.apikey != '') {
      this.controlService.getLogs(this.apikey)
      .then(async (data: any) => {
        // console.log("getLogs:", data);
        if(data.length>0) {
          await data.sort(this.compare);
          for(var i=0; i<data.length; i++) {
            var toPush = {
              buyername: data[i].customer,
              type: data[i].ticket,
              code: data[i].code,
              tsupdated: data[i].scanned_time,
              status: data[i].status,
              statusword: data[i].status
            };
            this.pushexistingtoentrylogs(toPush);
          }
        }
      })
      .catch(error => {
        console.log({error});
      });
    }
  }

  pushexistingtoentrylogs(topush) {
    this.entrylogs.push(topush);
    // console.log(topush);
  }

  // get logs count every 10 seconds
  getLogsCount() {
    if(this.apikey != '') {
      this.controlService.getLogsCount(this.apikey)
      .then(data => {
        // console.log("getLogsCount:", data);
        this.logsLiveCount = data;
      })
    }
  }

  // Safe wrapper that prevents overlapping requests
  private safeGetLogsCount() {
    if (this.isGettingLogsCount || this.apikey === '') {
      return;
    }
    
    this.isGettingLogsCount = true;
    this.controlService.getLogsCount(this.apikey)
      .then(data => {
        this.logsLiveCount = data;
      })
      .catch(error => {
        console.error('Error getting logs count:', error);
      })
      .finally(() => {
        this.isGettingLogsCount = false;
      });
  }

  // Get count of unsynced local data
  getUnsyncedDataCount(): number {
    const localCount = this.localData && Array.isArray(this.localData) ? this.localData.length : 0;
    const memoryCount = this.memoryFallback && Array.isArray(this.memoryFallback) ? this.memoryFallback.length : 0;
    return localCount + memoryCount;
  }

  // Open local data modal
  openLocalDataModal() {
    this.showLocalDataModal = true;
  }

  // Close local data modal
  closeLocalDataModal() {
    this.showLocalDataModal = false;
  }

  // Get unsynced local data (combined)
  getUnsyncedLocalData(): any[] {
    const combined: string[] = [];
    if (this.localData && Array.isArray(this.localData)) {
      this.localData.forEach((code: string) => {
        if (combined.indexOf(code) === -1) {
          combined.push(code);
        }
      });
    }
    if (this.memoryFallback && Array.isArray(this.memoryFallback)) {
      this.memoryFallback.forEach((code: string) => {
        if (combined.indexOf(code) === -1) {
          combined.push(code);
        }
      });
    }
    return combined;
  }
  
  // Manual sync trigger
  manualSync() {
    if (this.isConnected && !this.isSyncing) {
      this.syncLocalData();
    }
  }
  
  // Load allLogs from storage
  loadAllLogsFromStorage() {
    if (!this.storageAvailable && !this.checkStorageAvailability()) {
      console.warn('Storage not available, cannot load allLogs');
      this.allLogs = {};
      return;
    }
    
    try {
      const storageKey = this.getAllLogsStorageKey();
      const storedData = localStorage.getItem(storageKey);
      
      if (storedData) {
        let parsedData: any;
        try {
          parsedData = JSON.parse(storedData);
        } catch (parseError) {
          console.error('Invalid JSON in allLogs storage, clearing:', parseError);
          localStorage.removeItem(storageKey);
          this.allLogs = {};
          return;
        }
        
        // Validate data structure - should be an object
        if (parsedData && typeof parsedData === 'object' && !Array.isArray(parsedData)) {
          this.allLogs = parsedData;
          
          // Check if data is stale (older than 48 hours)
          const timestampKey = storageKey + '_timestamp';
          const timestamp = localStorage.getItem(timestampKey);
          if (timestamp) {
            const age = Date.now() - parseInt(timestamp);
            const maxAge = 48 * 60 * 60 * 1000; // 48 hours
            if (age > maxAge) {
              console.warn('allLogs data is stale (older than 48 hours), will refresh on next update');
            }
          }
        } else {
          console.warn('Invalid allLogs data structure, resetting');
          localStorage.removeItem(storageKey);
          this.allLogs = {};
        }
      } else {
        this.allLogs = {};
      }
    } catch (error) {
      console.error('Error loading allLogs from storage:', error);
      this.allLogs = {};
    }
  }

  // Save allLogs to storage
  saveAllLogsToStorage(): boolean {
    if (!this.storageAvailable && !this.checkStorageAvailability()) {
      return false;
    }
    
    try {
      const storageKey = this.getAllLogsStorageKey();
      
      // Validate allLogs structure
      if (!this.allLogs || typeof this.allLogs !== 'object' || Array.isArray(this.allLogs)) {
        console.warn('Invalid allLogs structure, not saving');
        return false;
      }
      
      const dataToStore = JSON.stringify(this.allLogs);
      
      // Check size before storing
      const sizeInBytes = new Blob([dataToStore]).size;
      if (sizeInBytes > 5000000) { // 5MB limit for allLogs
        console.warn('allLogs data too large, not saving');
        return false;
      }
      
      localStorage.setItem(storageKey, dataToStore);
      localStorage.setItem(storageKey + '_timestamp', Date.now().toString());
      
      return true;
    } catch (error) {
      console.error('Error saving allLogs to storage:', error);
      const err = error as any;
      if (err.name === 'QuotaExceededError' || err.code === 22) {
        console.warn('Storage quota exceeded, cannot save allLogs');
      }
      return false;
    }
  }

  // Merge server allLogs with local changes (preserve tickets marked as used offline)
  mergeAllLogs(serverLogs: any) {
    if (!serverLogs || typeof serverLogs !== 'object') {
      // If server data is invalid, keep existing local data
      return;
    }
    
    // Start with server data (most up-to-date)
    this.allLogs = serverLogs;
    
    // If we have local data, merge any local changes
    // Local changes are tickets that were marked as used offline (count = 1)
    // We want to preserve these even if server hasn't updated yet
    const localLogsKey = this.getAllLogsStorageKey() + '_local_changes';
    try {
      const localChanges = localStorage.getItem(localLogsKey);
      if (localChanges) {
        const parsedChanges = JSON.parse(localChanges);
        if (parsedChanges && typeof parsedChanges === 'object') {
          // Merge local changes (tickets marked as used) into server data
          Object.keys(parsedChanges).forEach((code: string) => {
            if (this.allLogs[code]) {
              // If ticket exists in server data, preserve local count if it's higher
              const localCount = parseInt(parsedChanges[code].count) || 0;
              const serverCount = parseInt(this.allLogs[code].count) || 0;
              if (localCount > serverCount) {
                this.allLogs[code].count = localCount;
              }
            }
          });
        }
      }
    } catch (error) {
      console.error('Error merging local changes:', error);
    }
  }

  // Save local changes (tickets marked as used offline) separately
  saveLocalLogChanges() {
    if (!this.storageAvailable) {
      return;
    }
    
    try {
      const localChanges: any = {};
      
      // Find tickets that were marked as used locally (count = 1)
      Object.keys(this.allLogs).forEach((code: string) => {
        if (this.allLogs[code] && parseInt(this.allLogs[code].count) >= 1) {
          localChanges[code] = {
            count: this.allLogs[code].count,
            timestamp: Date.now()
          };
        }
      });
      
      if (Object.keys(localChanges).length > 0) {
        const localLogsKey = this.getAllLogsStorageKey() + '_local_changes';
        localStorage.setItem(localLogsKey, JSON.stringify(localChanges));
      }
    } catch (error) {
      console.error('Error saving local log changes:', error);
    }
  }

  // Clear all local data (with confirmation)
  clearLocalData() {
    if (confirm('Are you sure you want to clear all unsynced local data? This cannot be undone.')) {
      this.localData = [];
      this.memoryFallback = [];
      const storageKey = this.getLocalStorageKey();
      try {
        localStorage.removeItem(storageKey);
        localStorage.removeItem(storageKey + '_timestamp');
        localStorage.removeItem(storageKey + '_memory');
      } catch (error) {
        console.error('Error clearing storage:', error);
      }
      this.closeLocalDataModal();
    }
  }

  // ========== Scanned Device Data Management ==========
  
  // Get storage key for scanned device data
  getScannedDeviceStorageKey(): string {
    return 'scanned_device_data';
  }

  // Load scanned device data from storage
  loadScannedDeviceData() {
    try {
      const storageKey = this.getScannedDeviceStorageKey();
      const storedData = localStorage.getItem(storageKey);
      if (storedData) {
        this.scannedDeviceData = JSON.parse(storedData);
      } else {
        this.scannedDeviceData = {};
      }
    } catch (error) {
      console.error('Error loading scanned device data:', error);
      this.scannedDeviceData = {};
    }
  }

  // Save scanned device data to storage
  saveScannedDeviceData() {
    try {
      const storageKey = this.getScannedDeviceStorageKey();
      localStorage.setItem(storageKey, JSON.stringify(this.scannedDeviceData));
    } catch (error) {
      console.error('Error saving scanned device data:', error);
    }
  }

  // Store a valid scanned entry
  storeScannedEntry(scannerData: any) {
    if (!this.apikey || !scannerData || scannerData.statusword !== 'Valid') {
      return;
    }

    // Initialize array for this API key if it doesn't exist
    if (!this.scannedDeviceData[this.apikey]) {
      this.scannedDeviceData[this.apikey] = [];
    }

    // Check if entry already exists (avoid duplicates)
    const exists = this.scannedDeviceData[this.apikey].some((entry: any) => entry.code === scannerData.code);
    if (!exists) {
      this.scannedDeviceData[this.apikey].push({
        code: scannerData.code,
        name: scannerData.buyername,
        type: scannerData.type,
        timestamp: new Date().toISOString(),
        date: new Date().toLocaleString()
      });
      this.saveScannedDeviceData();
    }
  }

  // Get all API keys with their counts
  getScannedDeviceApiKeys(): Array<{apikey: string, count: number}> {
    const keys = Object.keys(this.scannedDeviceData);
    return keys.map(apikey => ({
      apikey: apikey,
      count: this.scannedDeviceData[apikey] ? this.scannedDeviceData[apikey].length : 0
    })).sort((a, b) => b.count - a.count);
  }

  // Get total count of all scanned entries
  getTotalScannedCount(): number {
    let total = 0;
    Object.keys(this.scannedDeviceData).forEach(apikey => {
      if (this.scannedDeviceData[apikey] && Array.isArray(this.scannedDeviceData[apikey])) {
        total += this.scannedDeviceData[apikey].length;
      }
    });
    return total;
  }

  // Get count for current API key only
  getCurrentApiKeyScannedCount(): number {
    if (!this.apikey || !this.scannedDeviceData[this.apikey]) {
      return 0;
    }
    return Array.isArray(this.scannedDeviceData[this.apikey]) ? this.scannedDeviceData[this.apikey].length : 0;
  }

  // Export scanned data to CSV
  exportScannedDataToCSV(apikey?: string) {
    let dataToExport: any[] = [];
    let filename = 'scanned_device_data';

    if (apikey) {
      // Export specific API key
      if (this.scannedDeviceData[apikey]) {
        dataToExport = this.scannedDeviceData[apikey];
        filename = `scanned_device_data_${apikey}`;
      }
    } else {
      // Export all data
      Object.keys(this.scannedDeviceData).forEach(key => {
        if (this.scannedDeviceData[key] && Array.isArray(this.scannedDeviceData[key])) {
          this.scannedDeviceData[key].forEach((entry: any) => {
            dataToExport.push({
              ...entry,
              apikey: key
            });
          });
        }
      });
    }

    if (dataToExport.length === 0) {
      alert('No data to export');
      return;
    }

    // Convert to CSV
    const headers = apikey ? ['Code', 'Name', 'Type', 'Date', 'Timestamp'] : ['API Key', 'Code', 'Name', 'Type', 'Date', 'Timestamp'];
    const csvRows = [headers.join(',')];

    dataToExport.forEach((entry: any) => {
      // Format code as text to preserve leading zeros (Excel-safe format: ="value")
      const codeAsText = entry.code ? `="\"${String(entry.code).replace(/"/g, '""')}\""` : '=""';
      
      const row = apikey 
        ? [
            codeAsText,
            `"${(entry.name || '').replace(/"/g, '""')}"`,
            `"${(entry.type || '').replace(/"/g, '""')}"`,
            `"${(entry.date || '').replace(/"/g, '""')}"`,
            `"${(entry.timestamp || '').replace(/"/g, '""')}"`
          ]
        : [
            `"${(entry.apikey || '').replace(/"/g, '""')}"`,
            codeAsText,
            `"${(entry.name || '').replace(/"/g, '""')}"`,
            `"${(entry.type || '').replace(/"/g, '""')}"`,
            `"${(entry.date || '').replace(/"/g, '""')}"`,
            `"${(entry.timestamp || '').replace(/"/g, '""')}"`
          ];
      csvRows.push(row.join(','));
    });

    // Add UTF-8 BOM for Excel compatibility
    const BOM = '\uFEFF';
    const csvContent = BOM + csvRows.join('\n');
    const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' });
    const link = document.createElement('a');
    const url = URL.createObjectURL(blob);
    link.setAttribute('href', url);
    link.setAttribute('download', this.buildExportFileName(filename, apikey || this.apikey));
    link.style.visibility = 'hidden';
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  }

  exportAllCustomersListToCSV() {
    const rows = this.getCustomersFromAllLogs().map((customer: any) => ({
      apikey: this.apikey || '',
      code: customer.code || '',
      name: customer.name || '',
      type: customer.type || '',
      event: customer.event || '',
      status: this.getCustomerStatus(customer.count),
      count: customer.count || '0'
    }));

    this.exportCustomerRowsToCSV(rows, 'all_customers_list');
  }

  exportPendingCustomersListToCSV() {
    const rows = this.getCustomersFromAllLogs()
      .filter((customer: any) => parseInt(customer.count, 10) < 1)
      .map((customer: any) => ({
        apikey: this.apikey || '',
        code: customer.code || '',
        name: customer.name || '',
        type: customer.type || '',
        event: customer.event || '',
        status: 'Pending',
        count: customer.count || '0'
      }));

    this.exportCustomerRowsToCSV(rows, 'pending_customers_list');
  }

  exportScannedCustomersListToCSV() {
    if (!this.apikey) {
      alert('Please enter API key first');
      return;
    }

    const scannedRows = Array.isArray(this.scannedDeviceData[this.apikey]) ? this.scannedDeviceData[this.apikey] : [];
    const rows = scannedRows.map((entry: any) => ({
      apikey: this.apikey,
      code: entry.code || '',
      name: entry.name || '',
      type: entry.type || '',
      event: this.currEvent || '',
      status: 'Scanned',
      count: '1',
      date: entry.date || '',
      timestamp: entry.timestamp || ''
    }));

    this.exportCustomerRowsToCSV(rows, 'scanned_customers_list');
  }

  private getCustomersFromAllLogs(): any[] {
    if (!this.allLogs || typeof this.allLogs !== 'object') {
      return [];
    }

    return Object.keys(this.allLogs).map((code: string) => {
      const customer = this.allLogs[code] || {};
      return {
        code: code,
        name: customer.name || '',
        type: customer.type || '',
        event: customer.event || '',
        count: customer.count != null ? String(customer.count) : '0'
      };
    });
  }

  private getCustomerStatus(count: any): string {
    return parseInt(String(count), 10) >= 1 ? 'Scanned' : 'Pending';
  }

  private exportCustomerRowsToCSV(rows: any[], filename: string) {
    if (!rows || rows.length === 0) {
      alert('No data to export');
      return;
    }

    const escapeHtml = (value: any): string => String(value || '')
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;')
      .replace(/'/g, '&#039;');

    const tableRows = rows.map((row: any) => {
      const status = String(row.status || '').toLowerCase();
      let rowStyle = '';
      if (status === 'scanned') {
        rowStyle = 'background-color:#d4edda;';
      } else if (status === 'pending') {
        rowStyle = 'background-color:#f8d7da;';
      }

      return `
        <tr style="${rowStyle}">
          <td>${escapeHtml(row.apikey)}</td>
          <td style="mso-number-format:'\\@';">${escapeHtml(row.code)}</td>
          <td>${escapeHtml(row.name)}</td>
          <td>${escapeHtml(row.type)}</td>
          <td>${escapeHtml(row.event)}</td>
          <td>${escapeHtml(row.status)}</td>
          <td>${escapeHtml(row.count)}</td>
          <td>${escapeHtml(row.date)}</td>
          <td>${escapeHtml(row.timestamp)}</td>
        </tr>
      `;
    }).join('');

    const excelContent = `
      <html>
        <head>
          <meta charset="UTF-8">
          <style>
            table { border-collapse: collapse; width: 100%; }
            th, td { border: 1px solid #999; padding: 6px; text-align: left; }
            th { background-color: #f2f2f2; font-weight: bold; }
          </style>
        </head>
        <body>
          <table>
            <thead>
              <tr>
                <th>API Key</th>
                <th>Code</th>
                <th>Customer Name</th>
                <th>Ticket Type</th>
                <th>Event</th>
                <th>Status</th>
                <th>Count</th>
                <th>Date</th>
                <th>Timestamp</th>
              </tr>
            </thead>
            <tbody>
              ${tableRows}
            </tbody>
          </table>
        </body>
      </html>
    `;

    const blob = new Blob(['\uFEFF' + excelContent], { type: 'application/vnd.ms-excel;charset=utf-8;' });
    const link = document.createElement('a');
    const url = URL.createObjectURL(blob);
    link.setAttribute('href', url);
    link.setAttribute('download', this.buildExportFileName(filename, this.apikey, 'xls'));
    link.style.visibility = 'hidden';
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  }

  private buildExportFileName(baseName: string, apikey?: string, extension: string = 'csv'): string {
    const datePart = new Date().toISOString().split('T')[0];
    const apiKeyPart = this.sanitizeFileNamePart(apikey || 'no_apikey');
    const eventPart = this.sanitizeFileNamePart(this.currEvent || 'no_event');
    const basePart = this.sanitizeFileNamePart(baseName || 'export');
    return `${basePart}_${apiKeyPart}_${eventPart}_${datePart}.${extension}`;
  }

  private sanitizeFileNamePart(value: string): string {
    return String(value)
      .trim()
      .replace(/[^a-zA-Z0-9_-]+/g, '_')
      .replace(/^_+|_+$/g, '')
      .toLowerCase() || 'na';
  }

  // Delete scanned data for a specific API key
  deleteScannedData(apikey: string) {
    if (confirm(`Are you sure you want to delete all scanned data for API key "${apikey}"? This cannot be undone.`)) {
      if (this.scannedDeviceData[apikey]) {
        delete this.scannedDeviceData[apikey];
        this.saveScannedDeviceData();
      }
    }
  }

  // Delete all scanned data
  deleteAllScannedData() {
    if (confirm('Are you sure you want to delete ALL scanned device data? This cannot be undone.')) {
      this.scannedDeviceData = {};
      this.saveScannedDeviceData();
    }
  }

  // Sync scanned device data for a specific API key using bulk checkin
  syncScannedDeviceData(apikey: string) {
    if (!apikey || !this.scannedDeviceData[apikey] || !Array.isArray(this.scannedDeviceData[apikey]) || this.scannedDeviceData[apikey].length === 0) {
      alert('No data to sync for this API key');
      return;
    }

    if (!this.isConnected) {
      alert('Cannot sync: You are offline. Please connect to the internet and try again.');
      return;
    }

    if (this.syncingApiKeys[apikey]) {
      return; // Already syncing
    }

    // Confirm sync
    if (!confirm(`Sync ${this.scannedDeviceData[apikey].length} scanned codes for API key "${apikey}"?`)) {
      return;
    }

    this.syncingApiKeys[apikey] = true;

    // Extract all codes from the scanned data
    const codes = this.scannedDeviceData[apikey].map((entry: any) => entry.code);

    // Prepare data for bulk checkin
    const scannerdata = {
      codes: codes
    };

    this.controlService.checkinBulkCodes(apikey, codes)
      .then((data: any) => {
        console.log('Bulk sync successful:', data);
        alert(`Successfully synced ${codes.length} codes for API key "${apikey}"`);
        
        // Optionally clear the synced data or keep it for record
        // Uncomment the next lines if you want to delete after successful sync:
        // delete this.scannedDeviceData[apikey];
        // this.saveScannedDeviceData();
      })
      .catch((error: any) => {
        console.error('Bulk sync error:', error);
        alert(`Error syncing codes for API key "${apikey}": ${error.message || 'Unknown error'}`);
      })
      .finally(() => {
        this.syncingApiKeys[apikey] = false;
      });
  }

  // Check if an API key is currently syncing
  isApiKeySyncing(apikey: string): boolean {
    return this.syncingApiKeys[apikey] === true;
  }

  // Open scanned device modal
  openScannedDeviceModal() {
    this.loadScannedDeviceData();
    this.showScannedDeviceModal = true;
  }

  // Close scanned device modal
  closeScannedDeviceModal() {
    this.showScannedDeviceModal = false;
  }

}
